import React from 'react';

import { LinkButton } from '@atlaskit/button/new';

const LinkButtonRovoExample = (): React.JSX.Element => {
	return (
		<LinkButton appearance="rovo" href="https://atlassian.com/software/rovo">
			Rovo link button
		</LinkButton>
	);
};

export default LinkButtonRovoExample;
